import React from 'react';

import SearchForm from 'components/SearchForm';

import {
  OperatorSearchProps,
  OperatorTruckIndexRecord,
  SearchFormHandle,
} from 'lib/search';
import { typedForwardRef } from 'lib/utils';

/**
 * Search Form component with specific behavior to search Operator users
 */
function OperatorSearch(
  props: OperatorSearchProps<OperatorTruckIndexRecord>,
  ref: React.ForwardedRef<SearchFormHandle<OperatorTruckIndexRecord>>
) {
  return (
    <div className="operator-search-container isd-search-tw w-full">
      <SearchForm ref={ref} {...props} />
    </div>
  );
}

export default typedForwardRef(OperatorSearch);
